import { render, staticRenderFns } from "./promiseGoodsWrhsMngt.vue?vue&type=template&id=926d3878"
import script from "./promiseGoodsWrhsMngt.vue?vue&type=script&lang=js"
export * from "./promiseGoodsWrhsMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports